import { Product } from "@dashboard/modules/products/types/products.types";
import { CouponBucket } from "../constants/coupons.constants";
import { Coupon, CouponDraft } from "../entities/coupon.entity";
import { createEmptyCouponDraft } from "../utils/validate-coupon";

export interface CouponsUiState {
  searchQuery: string;
  activeFilters: CouponBucket[];
  showDeleteModal: boolean;
  isSaving: boolean;
  isLoading: boolean;
}

export interface CouponsDataState {
  coupons: Coupon[];
  catalogueProducts: Product[];
  draftCoupon: CouponDraft;
  selectedCoupon?: Coupon;
}

export interface CouponsState {
  ui: CouponsUiState;
  data: CouponsDataState;
}

export const initialState: CouponsState = {
  ui: {
    searchQuery: "",
    activeFilters: [],
    showDeleteModal: false,
    isSaving: false,
    isLoading: false,
  },
  data: {
    coupons: [],
    catalogueProducts: [],
    draftCoupon: createEmptyCouponDraft(),
    selectedCoupon: undefined,
  },
};
